var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6 u-pull-left tag-container filter-tag-container"},_vm._l((_vm.getTags()),function(tag,idx){return _c('div',{key:("tag-" + idx),staticClass:"tag tag--success"},[_c('strong',[_vm._v(_vm._s(tag))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }